// Translation: Account > Billing > Methods > Payment method removal dialog (Turkish)
export default Object.freeze({
	actions: {
		cancel: 'İptal',
		remove: 'Kaldır'
	},
	message: {
		text: 'Bu ödeme yöntemini kaldırmak istediğinize emin misiniz?',
		title: 'Ödeme yöntemi kaldırılacak'
	}
})
